// نمایش زمان‌های پشتیبانی (بکند همه را به دقیقه می‌دهد)
export function formatHours(minutes) {
  const hours = Number(minutes || 0) / 60;
  return `${Number.isInteger(hours) ? hours : hours.toFixed(1)} ساعت`;
}

export function formatMinutes(minutes) {
  const total = Math.round(Number(minutes || 0));
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (!h) return `${m} دقیقه`;
  return m ? `${h} ساعت و ${m} دقیقه` : `${h} ساعت`;
}

export function formatDate(date) {
  if (!date) return "-";
  const d = new Date(date);
  return isNaN(d) ? "-" : d.toLocaleDateString("fa-IR");
}

// اعتبار پکیج: ۷ روز به ازای هر ساعت از تاریخ ثبت (expireDate بکند فعلا ۳۰ روز ثابت است)
export function supportExpireDate(item) {
  if (!item || !item.createDate) return null;
  const start = new Date(item.createDate).getTime();
  if (isNaN(start)) return null;
  return new Date(start + (Number(item.capacityTime || 0) / 60) * 7 * 24 * 60 * 60 * 1000);
}
